import { type FC, useEffect, useRef } from "react";
import { renderBarcodeSVG } from "./BarcodeEncoder";

interface Props {
    value: string;
    height: number;
}

export const Barcode: FC<Props> = ({
    value,
    height,
}) => {
    const svgRef = useRef<SVGSVGElement>(null);

    useEffect(() => {
        if(!svgRef.current) {
            return;
        }

        try {
            renderBarcodeSVG(svgRef.current, height, value);
        } catch(err) {
            if(process.env.NODE_ENV === "test") {
                console.debug("Could not render barcode");
            } else {
                console.error("Could not render barcode", err);
            }
        }
    }, [ value, height ]);

    return (
        <svg
            ref={svgRef}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            className="barcode-canvas"
            preserveAspectRatio="none"
        />
    );
};
